import styled from 'styled-components';
import C from '@assets/themes/colors';

export const TextBoxContainer = styled.div`
  width: 100%;
  min-height: 40px;
  display: flex;
  flex-direction: row;
  margin: 14px 0px 0px 0px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background-color: #ffffff;
  align-items:center
`;

export const TextBoxInput = styled.span`
  width: 163px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #204078;
  margin: 0px 6px 0px 6px;
  border: none;
  outline: none;
  white-space: pre-wrap;
  align-items:center
`;

export const TextBoxCharactersCount = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #c4c4c4;
  margin: 0px 6px 0px 0px;
`;

export const ArrowContainer = styled.div`
  display: flex;
  margin: 4px 0px 4px 5px; 
`;

export const UpArrow = styled.div`
  width: 0; 
  height: 0; 
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #c4c4c4;
  margin-right: 4px;
  transform: rotate(-180deg);
  cursor: pointer;
`;

export const DownArrow = styled.div`
  width: 0; 
  height: 0; 
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #c4c4c4;
  margin-right: 4px;
  cursor: pointer;
`;

export const ArrowsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
